//画面サイズごとの処理
$(window).on('load resize', function(){
	const w = $(window).width();
	deviceFunc(w);
});

const browser=browserCheck();
const os=osCheck();
const device=deviceCheck();
$("body").addClass(browser).addClass(os);

const href=$(location).attr('href');
let host=	$(location).attr('hostname');
const topref=document.referrer;
const hash=$(location).attr('hash');

if(href.indexOf("/test/")>0)	{
	host=host + "/test";
}

$(document).ready(function(){

	if ( hash != '' ) {
    let pos = $( hash ).offset().top - $("header").height();
    $( 'html' ).animate({ scrollTop: pos }, 0 );
  }
	
  // <a href="#***">の場合、スクロール処理を追加
  $('[href*="#"]').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  		let $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name="' + this.hash.slice(1) +'"]');
      if ($target.length) {
      	const targetOffset = $target.offset().top - $("header").height();
        $('html,body').animate({ scrollTop: targetOffset }, 800, 'easeOutExpo');//fast
        //$('html,body').animate({ scrollTop: targetOffset }, 1000, 'easeInOutQuart');//smooth
        /*$('html, body').animate({scrollTop: targetOffset/5,opacity: 0}, 300, function() {
					$('html, body').animate({opacity: 1,scrollTop: targetOffset}, 600);
				});//fade scroll*/
        return false;
      }
    }
  });
  
  //dropmenu
  let hover;
	$('#gnavi .has-drop').hover(
	  function() {
		  let hasdrop=$(this);
	    hover = setTimeout(function() {
	      hasdrop.addClass("hover");
	    }, 200);
	  },
	  function() {
			let hasdrop=$(this);
			hasdrop.removeClass("hover");
	    clearTimeout(hover);
	  }
	)
  
  //Menu
  $('html').removeClass('scroll-prevent')
  $("#menu-btn").click(function(){
	  $("#menu").toggleClass("open");
	  //$('html').toggleClass('scroll-prevent')
  });
  
  //Submit
  if($('a.btn-submit').length){
	  $('a.btn-submit').on("click",function() {
  		$(this).closest("form").submit();
		});
  }
  
  //トップページ
  if($("#home").length){
	  if(topref && topref.indexOf(host) >= 0){//同一ドメイン内からのアクセスか
			$('#cover').fadeOut(800,function(){
	      $(this).remove();
	      $(".pace").remove();
	      $(".key-tagline").addClass("is-show");
	      $(".key-title").addClass("is-show");
      });
		}else{
		}

		var video=$("#key-video").get(0);
		var videoSrc="https://" + host + "/images/key.mp4";
		video.src=videoSrc;
		video.addEventListener('loadstart', function(){ 
			console.log('loadstart');
			video.playbackRate=0.4;
			video.defaultPlaybackRate=0.4;
			video.muted = true;
			video.loop = true;
		});
		video.addEventListener('canplaythrough', function(){ 
			console.log('canplaythrough');
			video.play(); 
		});
		video.addEventListener('ended', function(){ 
			console.log('ended'); 
		});
	  
	  Pace.on('done', function(){
      $('#cover').fadeOut(1000,function(){
	      $(this).remove();
	      $(".pace").remove();
	      $(".key-tagline").addClass("is-show");
	      $(".key-title").addClass("is-show");
      });
    });
    
    
    //タブ
	  $(".tab1").addClass("active");  
		$(".top-info-tabs li").click(function(){
	    $(".top-info-tabs .active").removeClass("active");
	    $(".top-info-tab-contents .active").removeClass("active");
	
			var i = $(".top-info-tabs li").index(this)+1;
	    id="tab"+i;
			
	    $(this).addClass("active");
	    
	    $(".top-info-tab-contents ."+id).addClass("active");
	    
	  });
	} 
	
	//タクトの特徴
	if($("#recruit.bn-feature").length){
	  var ctx1 = document.getElementById("chart1").getContext('2d');
	  var myChart1 = new Chart(ctx1, {
	    type: 'pie',
	    data: {
	        labels: ["20代", "30代", "40代", "50代"],
	        datasets: [{
	            data: [3,19, 67, 11],
	            backgroundColor: ["#000650","#002173","#2e4fa0","#7b90c5","#bbc6e3"],
	            borderWidth: 0
	        }]
	    },
	    options: {
		    legend:{
			    position:"right",
			    labels:{
				    boxWidth:20,
			    },
			    onClick: function(){ return false; }
		    },
		    tooltips:{
			    backgroundColor:"#ffffff",
			    bodyFontColor:"#555555",
			    caretSize:4,
			    cornerRadius:2,
			    callbacks: {
	          label: function (tooltipItem, data) {
	            return data.labels[tooltipItem.index]
	              + ": "
	              + data.datasets[0].data[tooltipItem.index]
	              + "%"; //ここで単位を付けます
	          }
	        }
		    }
	    },
	    plugins: [dataLabelPlugin]
		});
		
		$(".chart2-list li").each(function(){
			let delay=0.5;
			let index=$(".chart2-list li").index(this);
			delay=delay + (0.02 * index) + "s";
			$(this).css({"transition-delay":delay});
		});
  }
	
	//ニュース・トピックス・お知らせ
	if($(".entry-body").length){
		$(".entry-body table").addClass("nobreak").wrap('<div class="scroll-tb"></div>');
	}
	
	if($('img[usemap]').length){
		$('img[usemap]').rwdImageMaps();
	}
	
	//遺産整理業務
	if($(".qa-title").length){
		$(".qa-title").on("click",function(){
			$(this).toggleClass("is-show");
			$(this).next(".qa-text").slideToggle();
		});
	}
	
  //inView
  $('.anm').on('inview', function(event, isInView) {
    if (isInView) {
    //表示領域に入った時
      $(this).addClass('is-show');
      if($("#recruit.bn-feature").length){
				if($(this).attr("id") == "number1"){$(this).html("42.9");	}
				if($(this).attr("id") == "number2"){$(this).html("94");}
				if($(this).attr("id") == "number3"){$(this).html("5");}
				if($(this).attr("id") == "number4"){$(this).html("4");}
			}
    } else {
    //表示領域から出た時
     	//$(this).removeClass('is-show');
    }
  });

  
  //scroll
  $(window).scroll(function () {
	 	const body = window.document.body;
	 	const html = window.document.documentElement;
	 	const scrTop = body.scrollTop || html.scrollTop;
	 	const scrBottom = html.scrollHeight - html.clientHeight - scrTop;
	 	if(scrTop > 40){
			$("body").addClass("is-scroll");
		}else{
			$("body").removeClass("is-scroll");
		}
		if(scrTop > 300){
			$(".pagetop").addClass("is-show");
		}else{
			$(".pagetop").removeClass("is-show");
		}
		
		if($(".cart").length){
			$cart=$(".cart");
			const absScrTop=scrTop - $(".main").offset().top 
			
			if(absScrTop < 0){
				$cart.css({"top": 100 });
			}else if(absScrTop >= $(".main").height() -100){
				$cart.css({"top": $(".main").height() });
			}else{
				$cart.css({"top": absScrTop+100 });
			}
			if(scrBottom <= 20){
				$cart.addClass("is-bottom");
			}else{
				$cart.removeClass("is-bottom");
			}
		}
		
		
  });
  
  
  //GoogleMapAPI
	if($("#gmap").length){
		const styles=[
    {
        "featureType": "all",
        "stylers": [
            {
                "saturation": -30
            },
            {
                "hue": "#5f6e78"
            }
        ]
    },
    {
        "featureType": "road",
        "stylers": [
            {
                "saturation": -70
            }
        ]
    },
    {
        "featureType": "water",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "saturation": -60
            }
        ]
    }
];
		googlemap({
			"wrapid" : "gmap",
			"tit" : "タクトコンサルティング",
			"styles" : styles,
			"lat" : 35.678819,
			"lng" : 139.762139,
			"maplat" : 35.678819, //mapの中心
			"maplng" : 139.762139, //mapの中心
			"zoom" : 17,
			"infoshow" : false,
			"window" : "<dl id='infowin'><dt>タクトコンサルティング</dt><dd>〒100-0005 <br>東京都千代田区丸の内2-1-1 <br>明治安田生命ビル17F</dd></dl>",
			"icon" : "https://" + host +"/common/images/gmap_marker.png",
			"iconw" : 40,
			"iconh" : 40
		});
	}
	
	//exValidation
	if($(".validationform").length){
		//inputの下にエラー
		const validation = $(".validationform").exValidation({
			errInsertPos :"after",
			errPosition :"fixed",
		  stepValidation: true,
		  errHoverHide:false,
		  errTipCloseBtn:false,
		  scrollAdjust:-$("header").height(),
		  errMsgPrefix : ""
		});
	}
	
	if($(".validationform2").length){
		//inputの下にエラー
		const validation = $(".validationform2").exValidation({
			errInsertPos :"after",
			errPosition :"fixed",
		  stepValidation: true,
		  errHoverHide:false,
		  errTipCloseBtn:false,
		  scrollAdjust:-$("header").height(),
		  errMsgPrefix : ""
		});
	}
	
	if($("#zip1").length && $("#zip2").length){
		$("#zip1").on('input',function(){
			AjaxZip3.zip2addr('zip1','zip2','address','address','','',false);
		});
		$("#zip2").on('input',function(){
			AjaxZip3.zip2addr('zip1','zip2','address','address','','',false);
		});
	}
	if($("#slip_user_post").length){
		$("#slip_user_post").on('input',function(){
			AjaxZip3.zip2addr(this,'','slip_user_address1','slip_user_address1','','',false);
		});
	}
	if($("#tels").length){
		let flag=new Array();
		if($("#tel").val() || $("#tel2").val() || $("#tel3").val()){
			$("#tels").removeClass("chkrequired");
		}
		$("#tels input").on('blur keyup change click',function(){
			$("#tels input").each(function(i){
				flag[i]=0;
				if($(this).val() != ""){
					flag[i]=1;
				}
			});
			let total = flag.reduce(function(total, data){
				return total + data;
			});
			if(total>0){
				$("#tels").removeClass("chkrequired");
			}else{
				$("#tels").addClass("chkrequired");
			}
			console.log(total);
		});
	}
	
	
	
});



function deviceFunc(w){
	const bp = [559,959,1280];
	if (w <= bp[0]) {
		//sp
		$(".tel-number").each(function(){
			if(!$(this).parent(".tel-wrap").length){
				const no = $(this).data("tel");
				$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
			}
		});
  } else if(w <= bp[1]){
		//tb
		$(".tel-wrap .tel-number").each(function(){
			$(this).unwrap();
		});
  } else if(w <= bp[2]){
		//small pc
  } else{
  
  }
}
//GoogleMapAPI
function googlemap(opt){
	const latlng = new google.maps.LatLng(opt.lat,opt.lng);
	const maplatlng = new google.maps.LatLng(opt.maplat,opt.maplng);
  const myOptions = {
    zoom: opt.zoom, /*拡大比率*/
    center: maplatlng, /*表示枠内の中心点*/
    tilt:0,
    styles:opt.styles,
    scrollwheel: false,
    mapTypeControl:false,
    mapTypeId: google.maps.MapTypeId.ROADMAP/*表示タイプの指定*/
  };
  const map = new google.maps.Map(document.getElementById(opt.wrapid), myOptions);
 
	/*アイコン設定▼*/
	const iconimage = {
		url:opt.icon,
		scaledSize : new google.maps.Size(opt.iconw,opt.iconh),
		origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(opt.iconw/2, opt.iconh/2)
	}
	
  const markerOptions = {
    position: latlng,
    map: map,
    title: opt.tit,
    icon:iconimage
  };
  const marker = new google.maps.Marker(markerOptions);
　/*アイコン設定ここまで▲*/

	/*情報ウィンドウ*/
  const contentString=opt.window;
  const infowindow=new google.maps.InfoWindow({
      content: contentString
  });
  if(opt.infoshow){
	  infowindow.open(map,marker);//表示
	}
  /* マーカーがクリックされた時に情報ウィンドウ表示 */
  google.maps.event.addListener(marker, 'click', function() {
    infowindow.open(map,marker);
  });
}

/*ブラウザ判別*/
function browserCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	const av = window.navigator.appVersion.toLowerCase();
	if(ua.indexOf('edge') != -1){
		return 'edge';
	}else if (ua.indexOf('opera') != -1) {
  	return 'opera';
	}else if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
		$("body").addClass('ie');
  	if (av.indexOf("msie 6.") != -1) {
    	return 'ie6';
  	} else if (av.indexOf("msie 7.") != -1) {
    	return 'ie7';
  	} else if (av.indexOf("msie 8.") != -1) {
    	return 'ie8';
  	} else if (av.indexOf("msie 9.") != -1) {
    	return 'ie9';
  	}else if (av.indexOf("msie 10.") != -1) {
    	return 'ie10';
  	}else if (av.indexOf("rv:11.") != -1) {
    	return 'ie11';
  	}
	} else if (ua.indexOf('chrome') != -1) {
  	return 'chrome';
	} else if (ua.indexOf('safari') != -1) {
  	return 'safari';
	} else if (ua.indexOf('gecko') != -1) {
  	return 'firefox';
	} else {
  	return false;
	}
}

/*OS判別*/
function osCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('windows') != -1) {
		if(ua.indexOf('phone') != -1){
			return 'winphone';
		}else{
			return 'win';
		}
	}else if(ua.indexOf('iphone') != -1) {
		return 'iphone';
	}else if(ua.indexOf('ipad') != -1) {
		return 'ipad';
	}else if(ua.indexOf('mac') != -1) {
		return 'mac';
	}else if(ua.indexOf('android') != -1) {
		if(ua.indexOf('mobile') != -1){
			if(ua.indexOf('A1_07') != -1){
				return 'tablet';
			}else if(ua.indexOf('SC-01C') != -1){
				return 'tablet';
			}else{	return 'android';}
		}else{
			return 'tablet';
		}
	}else{
		return false;
	}
}

/*デバイス判別*/
function deviceCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if((ua.indexOf("windows") != -1 && ua.indexOf("touch") != -1 && ua.indexOf("tablet pc") == -1) 
      || ua.indexOf("ipad") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") == -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("tablet") != -1)
      || ua.indexOf("kindle") != -1
      || ua.indexOf("silk") != -1
      || ua.indexOf("playbook") != -1){
      return 'tab';
    }else if((ua.indexOf("windows") != -1 && ua.indexOf("phone") != -1)
      || ua.indexOf("iphone") != -1
      || ua.indexOf("ipod") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") != -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("mobile") != -1)
      || ua.indexOf("blackberry") != -1){
	    return 'sp';
    }else{
      return 'pc';
    }
}

var dataLabelPlugin = {
	afterDatasetsDraw: function (chart, easing) {
      // To only draw at the end of animation, check for easing === 1
      var ctx = chart.ctx;

      chart.data.datasets.forEach(function (dataset, i) {
          var meta = chart.getDatasetMeta(i);
          if (!meta.hidden) {
              meta.data.forEach(function (element, index) {
                  // Draw the text in black, with the specified font
                  ctx.fillStyle = '#ffffff';

                  var fontSize = 14;
                  var fontStyle = 'normal';
                  var fontFamily = 'Helvetica Neue';
                  ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

                  // Just naively convert to string for now
                  var dataString = dataset.data[index].toString() + "%";

                  // Make sure alignment settings are correct
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
										
                  
									var position = element.tooltipPosition();
									var padx = (element._model.x-position.x)/2.5;
									var pady = (element._model.y-position.y)/2.5;
									var px = position.x;
                  var py = position.y - (fontSize / 2);
									
                  ctx.fillText(dataString, px - padx,py - pady);
              });
          }
          
                 
      });
  }
};
